export default __webpack_public_path__ + "static/media/pointer.db617ea9.png";